<template>
  <div>
    <iframe ref="iframe" id="myiframe"
            frameborder="0" style="width: 100%;height: 100%;overflow: auto;" allowfullscreen></iframe>
  </div>

</template>


<script>

import {getCloudUrl} from "@/utils/urlutil";

export default {
  name: "txVideoPlayer",
  data() {
    return {}
  },
  props: {
    videoUrl: {
      type: String
    },
    preload: {
      type: String,
      default: "auto"
    },
    poster: {
      type: String,
      default: ""
    }
  },
  async created() {
  },
  mounted() {
    this.$refs['iframe'].contentWindow.location.replace(`https://siuitestpub.oss-cn-qingdao.aliyuncs.com/test/txVideoPlayer4Iframe.html?src=${getCloudUrl(this.videoUrl)}&poster=${getCloudUrl(this.poster)}&preload=${this.preload}`)
  },
  methods: {},
  watch: {
    videoUrl: {
      handler(newVal, oldVal) {
        this.$refs['iframe'].contentWindow.location.replace(`https://siuitestpub.oss-cn-qingdao.aliyuncs.com/test/txVideoPlayer4Iframe.html?src=${getCloudUrl(this.videoUrl)}`)
      },
    }
  }
}
</script>

<style scoped>

</style>